export default __webpack_public_path__ + "static/media/IMG_0411.336e4c1b.jpg";